import { z } from 'zod';
import * as address from '../../primitives/address';
import {
  AlphanumericMessage,
  maxCharMessage,
  NotBlankMessage,
  RequiredMessage,
} from '../../validation/messages';

const requiredAddressLine1 = z
  .string()
  .min(1, RequiredMessage)
  .max(500, maxCharMessage(500))
  .regex(/^\s*\S[\s\S]*$/, NotBlankMessage)
  .regex(/^[a-zA-Z0-9 .,]*$/, AlphanumericMessage)
  .refine((v) => !v.includes('  '), 'Must not contain double spaces');

export const addressBlock = z.object({
  addressLine1: requiredAddressLine1,
  addressLine2: address.addressLine2.schema.optional(),
  countryId: z.string().min(1, RequiredMessage),
  stateId: z.string().min(1, RequiredMessage),
  cityText: address.city.schema.optional(),
  zipCode: address.zipCode.schema,
});

export const internationalAddressBlock = addressBlock.extend({
  zipCode: address.zipCode.schema.optional(),
  stateId: z.string().optional(),
  stateText: address.state.schema.optional(),
});

export type AddressBlock = z.infer<typeof addressBlock>;
export type InternationalAddressBlock = z.infer<typeof internationalAddressBlock>;
